import { render, staticRenderFns } from "./log.vue?vue&type=template&id=2422d1f2&scoped=true&"
import script from "./log.vue?vue&type=script&lang=js&"
export * from "./log.vue?vue&type=script&lang=js&"
import style0 from "./log.vue?vue&type=style&index=0&id=2422d1f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2422d1f2",
  null
  
)

export default component.exports